import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'webchat-index-message',
  templateUrl: './index-message.component.html',
  styleUrls: ['./index-message.component.scss']
})
export class IndexMessageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
